/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';
import { IldsFooterProps } from '../lds-footer.data';

const TermsAndConditions: React.FC<IldsFooterProps> = ({ salesAndRefundPolicy, impressum, salesTitle, impressumTitle, onClick }) => {
    return (
        <div className='termsAndConditionsWithImpressum'>
            <div className='termsAndConditions'>
                <a
                    className='termAndCondition'
                    onClick={() =>
                        salesAndRefundPolicy && salesAndRefundPolicy.PolicyType ? onClick(salesAndRefundPolicy.PolicyType) : ''
                    }
                    target='_blank'
                    rel='noreferrer'
                    style={{ cursor: 'pointer' }}
                >
                    {salesTitle ||
                        salesAndRefundPolicy?.DESCRIPTION ||
                        salesAndRefundPolicy?.Description ||
                        salesAndRefundPolicy?.PolicyType}
                </a>
            </div>
            <div className=''>
                <a
                    className='termAndConditionImpressum'
                    onClick={() => (impressum && impressum.PolicyType ? onClick(impressum.PolicyType) : '')}
                    target='_blank'
                    rel='noreferrer'
                    style={{ cursor: 'pointer' }}
                >
                    {impressumTitle || impressum?.DESCRIPTION || impressum?.Description || impressum?.PolicyType}
                </a>
            </div>
        </div>
    );
};

export default TermsAndConditions;
